import { useSelector } from 'react-redux';

import { Typography } from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import { SentForReviewContainerStyled } from './style';
import UploadedPDFView from './UploadedPDFView';

const SentForReview = () => {
  const jobProcess = useSelector((state: RootState) => state.singleJobProcess);

  const latestReview =
    jobProcess.review && jobProcess.review.length > 0
      ? jobProcess.review[0]
      : null;

  return (
    <SentForReviewContainerStyled>
      <Typography className="section-title" strong fontColor="secondary">
        SENT PDF
      </Typography>
      {latestReview && <UploadedPDFView review={latestReview} />}
    </SentForReviewContainerStyled>
  );
};

export default SentForReview;
